<template>
	<div class="home">
		<div class="container-fluid">
			<div id="portafolio">
				<div class="row">
					<div class="col s12 portafolio__header">
						<h2 class="center">Portafolio</h2>
						<a @click="home()">Home</a>
					</div>
					<div class="col s12 portafolio__images">
						<div class="image-box">
							<div @click="showModalVideo()" class="video-wrapper"></div>
							<img class="background-image" src="../assets/videos/poster.png" style="filter: blur(2px)">
							<img @click="showModalVideo()" class="icon-image" src="../assets/images/icons/video.svg" alt="">
						</div>
						<div class="image-box" v-for="(image, index) in images">
							<img class="background-image" :src="getSrc(image.Foto)" alt="" @click="showModalImage(), url = image.Foto, photograph = image.Fotografo, flowers = image.Flores">
						</div>
					</div>
				</div>
			</div>

			<modal name="image-modal" height="auto" v-if="url !== null">
				<div class="header">
					<div class="icon-wrapper" @click="hideModalImage">
						<img src="../assets/images/icons/close.svg" alt="">
					</div>
				</div>
				<div class="image">
					<img :src="getSrc(url)" alt="">
				</div>
				<div class="info">
					<p v-if="photograph !== ''"><b>Fotógrafo:</b> {{ photograph }}</p>
					<p v-if="flowers !== ''"><b v-if="showFlowersWord(flowers)">Decoración:</b> {{ flowers }}</p>
				</div>
			</modal>

			<modal name="video-modal" height="auto">
				<div class="header">
					<div class="icon-wrapper" @click="hideModalVideo">
						<img src="../assets/images/icons/close.svg" alt="">
					</div>
				</div>
				<div class="video">
					<video controls="" autoplay>
						<source src="../assets/videos/video.mp4" type="video/mp4">
					</video>
				</div>
				<div class="info">
					<p><b>Autor</b>: franciscoeditor@hotmail.com</p>
				</div>
			</modal>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import VModal from 'vue-js-modal'
import axios from 'axios';

Vue.use(VModal)

export default {
	name: 'Portafolio',
	data () {
		return {
			// Images
			images: [],
			url: null,
			photograph: '',
			flowers: '',
			// 
			video: false,
		}
	},
	methods: {
		// Img
		getSrc(name) {
	        var images = require.context('../assets/fotografias/', false, /\.jpg$/);
	        return images('./' + name + ".jpg")
	    },
	    // 
		showModalImage () {
		    this.$modal.show('image-modal');
		},
		hideModalImage () {
			this.$modal.hide('image-modal');
		},
		// 
		showModalVideo () {
		    this.$modal.show('video-modal');
		},
		hideModalVideo () {
			this.$modal.hide('video-modal');
		},

		showFlowersWord (flowers) {
			let final = true

			if (flowers === "Tutto Dolce" || flowers === "Dulces Enchilados de Natalia Moreno" || flowers === "Monema") {
				final = false
			}

			return final;
		},

		home () {
			this.$router.push({name: 'Tool'});
		}
	},
	mounted () {
		axios
			.get('static/images.json')
			.then(response => (this.images = response.data))
	},
	components: {}
};
</script>

<style lang="scss">
$gray: #e6ddcc;
$pink: #e24a9b;
$white: #ffffff;
$black: #000000;

@font-face {
	font-family: 'Montserrat';
	src: url('../assets/font/Montserrat-Regular.ttf');
}

body {
	position: relative;
}

h2 {
	text-transform: uppercase;
	color: $pink;
	font-size: 18px;
	font-weight: bold;
	margin-bottom: 20px;
}

h2, p {
	font-family: 'Montserrat', sans-serif;
}

a {
	color: $pink;
	font-family: 'Montserrat', sans-serif;
}

.home {
	#portafolio {
		position: relative;
		padding: 5%;

		.portafolio__header {
			a {
				cursor: pointer;
			}
		}

		.portafolio__images {
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;
			padding: 0px;

			.image-box {
				position: relative;
				width: 19%;
				padding-top: 19%;
				margin: 0.5%;
				overflow: hidden;

				.background-image, video {
					position: absolute;
					transform: translateX(-50%) translateY(-50%);
					top: 50%;
					left: 50%;
					width: auto;
					max-width: 120%;
					max-height: 120%;
					min-width: 100%;
					min-height: 100%;
					cursor: pointer;
				}

				.icon-image {
				    position: absolute;
				    z-index: 56;
				    height: 70px;
				    transform: translateX(-50%) translateY(-50%);
				    top: 50%;
				    left: 50%;
				    cursor: pointer;
				}

				video {
					max-width: initial;
				}
			}

			.video-wrapper {
			    position: absolute;
			    background: rgba(0, 0, 0, .60);
			    top: 0;
			    bottom: 0;
			    left: 0;
			    right: 0;
			    z-index: 5;
			    cursor: pointer;

			}
		}
	}
}

.v--modal-overlay {
	.v--modal-background-click {
		display: flex;
		justify-content: center;
		align-items: center;
	    background: rgba(0, 0, 0, 0.90) !important;

	    .v--modal-box {
    	    top: 0 !important;
		    left: 0 !important;
		    width: 80% !important;
    		height: 90vh !important;
    		background-color: transparent;
    		box-shadow: none !important;
    		color: white;
    		font-size: 14px;

    		.header {
    			height: 8%;
    			text-align: center;
    			display: flex;
    			justify-content: center;
    			align-items: center;

    			.icon-wrapper {
				    width: 30px;
				    height: 30px;
				    background: rgba(255, 255, 255, 0.16);
				    border-radius: 50px;
				    display: flex;
				    justify-content: center;
				    align-items: center;
				    cursor: pointer;

				    img {
				    	height: 10px;
					}
    			}
    		}

    		.image {
    			position: relative;
    			height: 84%;

    			img {
			    	width: auto;
			    	height: auto;
			    	min-height: 100%;
			    	max-height: 100%;
		    	    transform: translateX(-50%) translateY(-50%);
				    left: 50%;
				    top: 50%;
				    position: absolute;
				}
    		}

    		.video {
    			display: flex;
    			justify-content: center;
    			align-items: center;
    			height: 92%;
    		}

    		.info {
    			height: 8%;
    			text-align: center;
    		}
		}
	}
}

@media screen and (max-width: 800px) {
	.home {
		#portafolio {
			.portafolio__images {
				.image-box {
					width: 32%;
					padding-top: 32%;
				}
			}
		}
	}

	.v--modal-overlay {
		.v--modal-background-click {
		    .v--modal-box {
	    		.header {
	    			height: 20%;
	    		}

	    		.image {
	    			position: relative;
	    			height: 60%;

	    			img {
				    	min-height: auto;
				    	max-width: 100%;
					}
	    		}

	    		.video {
	    			height: 80%;
	    			max-width: 100%;

	    			video {
	    				max-width: 100%;
	    			}
	    		}

	    		.info {
	    			height: 20%;
	    		}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/Portafolio.vue